export const adiantarDataAgendamento = (pedido) => {
  let dtCriacao = new Date(pedido.createdAt);
  let dtAgendamento = new Date(pedido.dataAgendamento);
  let diff = (dtAgendamento.getTime() - dtCriacao.getTime()) / 3600000;

  if(diff > 1){
    dtAgendamento.setHours(dtAgendamento.getHours() - 1);
    return dtAgendamento;
  }
  return dtAgendamento;
}